import type { LineStyle, PolygonStyle, TextStyle } from "building-types/views/Primitive2DOutput";
import type { SheetGeometryType } from "building-types/views/sheetGeometryTypes";
import type { StyleSheet } from "../planStyles";

export type StyleHash<Delimiter extends string, Name extends string> = `${Delimiter}${Name}`;

export const TYPE_DELIMITER = "__type__.";
export type TypeDelimiter = typeof TYPE_DELIMITER;
export type TypeHash<T extends string> = StyleHash<TypeDelimiter, Lowercase<T>>;

export const TAG_DELIMITER = "__tag__.";
export type TagDelimiter = typeof TAG_DELIMITER;
export type TagHash<T extends string> = StyleHash<TagDelimiter, T>;

export type GeometryStylesInternal = {
  [SheetGeometryType.POLYLINE]: LineStyle;
  [SheetGeometryType.POLYGON]: PolygonStyle;
  [SheetGeometryType.CIRCLE]: LineStyle;
  [SheetGeometryType.ARC]: LineStyle;
  [SheetGeometryType.TEXT]: TextStyle;
  // [SheetGeometryType.ASSET]: {}; // no style currently
  // [SheetGeometryType.SVG]: {}; // no style currently
};

export type GeometryStyleSheet = StyleSheet<{
  [K in keyof GeometryStylesInternal as TypeHash<K>]?: GeometryStylesInternal[K];
}>;

export type TagStylesInternal = Record<string, LineStyle | TextStyle>;

export type TagStyleSheet = StyleSheet<{
  [K in keyof TagStylesInternal as TagHash<K>]?: TagStylesInternal[K];
}>;

export type SheetGeometryStyleSheet = GeometryStyleSheet &
  TagStyleSheet & {
    line?: LineStyle;
    text?: TextStyle;
  };
